module.exports = __webpack_public_path__ + "static/media/Icon_Error.2489a5f8.svg";